import React, { useEffect } from "react";
import UserHeaderClient from "./UserHeaderClient";
import { Box, Flex } from "@chakra-ui/react";
import { Outlet, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import "./Client.scss";

const UserInnerLayout = () => {
  // const { data: clientData } = useSelector((state) => state.clientReducer);
  return (
    <Box w="100%" bg="var(--body-bg)">
      <Box>
        <UserHeaderClient />
      </Box>
      <Flex>
        <Box
          w="100%"
          h="calc(100% - var(--headerbar-height) - var(--footerbar-height))"
          padding={"10px"}
        >
          <Outlet />
        </Box>
      </Flex>
    </Box>
  );
};

export default UserInnerLayout;
